import {type} from 'arktype';

export const Document = type({
    title: 'string',
    url: 'string.url',
});

export type Document = typeof Document.infer;
